import { kebabCase } from 'lodash';
import React, { useRef, useEffect, forwardRef } from 'react';

const useProps = (nodeRef, newProps) => {
  useEffect(() => {
    const node = nodeRef.current;
    const eventsCache = {};

    if (node instanceof Element) {
      Object.keys(newProps).forEach((name, value) => {
        if (
          name === 'children'
          || name === 'style'
          || name === 'ref'
          || name === 'class'
          || name === 'className'
          || name === 'forwardedRef'
          || name === 'type'
          || name === 'format'
        ) {
          return;
        }

        const propType = typeof newProps[name];

        // Check if prop is event handler
        if (name.indexOf('on') === 0  && propType === 'function' && name[2] === name[2].toUpperCase()) {
          const eventName = name.substring(2);
          const eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
          const eventHandler = newProps[name];
          const callback = function handler(e) {
            if (eventHandler) {
              eventHandler(e);
            }
          };

          eventsCache[eventNameLc] = callback;
          node.addEventListener(eventNameLc, callback);
        } else {          
          if (propType === 'string') {
            node.setAttribute(kebabCase(name), newProps[name]);
          } else {
            node[name] = newProps[name];
          }
        }
      });
    }

    return () => {
      // Remove event listeners
      const eventNames = Object.keys(eventsCache);
      eventNames.forEach((eventName) => {
        const handler = eventsCache[eventName];
        if (handler) {
          node.removeEventListener(eventName, handler);
        }
      });
    };
  });
};

export const createReactComponent = (LimeElement) => forwardRef((props, ref) => {
  const internalRef = useRef();
  const elementRef = ref || internalRef;
  const {
    // eslint-disable-next-line react/prop-types
    class: nativeClass, className, style, type, format, children,
  } = props;

  useProps(elementRef, props);
  return (
    <LimeElement
      ref={elementRef}
      class={className || nativeClass}
      style={style}
      type={type}
      format={format}
    >
      {children}
    </LimeElement>
  );
});
